<div class="row customer-picker" *ngIf="showAgreements">
    <div class="col-sm-48 offset-md-14 col-md-20">
        <page-header [header]="'Select account' | translate"></page-header>
        <table-search [minSearchLength]="1"
                      class="block mb-3"
                      [placeholderTxt]="'Search...' | translate"
                      [model]="search"
                      (getPage)="onSearch($event)">
        </table-search>
        <div class="card panel-monsido-card" *ngFor="let agreement of filterAgreements()">
            <div class="card-body py-5" 
                 [attr.data-test]="'select-account-' + agreement.account.name | e2eAttributeEncoding" 
                 (click)="selectAgreement(agreement)" 
                 [attr.aria-label]="('Select account' | translate) + ' ' + agreement.account.name" 
                 role="button">
                {{ agreement.account.name }}
            </div>
        </div>
    </div>
</div>

<div class="row" *ngIf="showError">
    <div class="col-sm-48 offset-md-14 col-md-20">
        <div class="alert alert-danger" role="alert">
            {{ 'No account is linked to the selected organization. Please contact your administrator.' | translate }}
        </div>
    </div>
</div>
